import axios from './requestClient';

export async function fetchBrands() {
  return axios.get(`/api/v1/Brand`);
}
